import axios from "axios";
import { DataGrid, LoadPanel } from "devextreme-react";
import {
  Column,
  Editing,
  FilterRow,
  FormItem,
  HeaderFilter,
  Lookup,
  Form,
  StateStoring,
} from "devextreme-react/data-grid";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";

import { useState, useEffect } from "react";
import { LOC } from "./data";

export default function Arrangement(props) {
  const [dataSource, setDataSource] = useState([]);
  const [employee, setEmployee] = useState(null);

  const { type, SEQ } = props;

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BECCO_API_URL}/api/employee`)
      .then((result) => {
        setEmployee(result.data);
      });
  }, []);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "id",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/eqptArr/${type}/${SEQ}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/eqptArr/${type}/${SEQ}`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/eqptArr/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/eqptArr/${key}`
          );
        },
      })
    );
  }, [type, SEQ]);

  // const onEditorPreparing = (e) => {
  //   if (e.dataField == "employeeNo" && e.parentType == "dataRow") {
  //     e.editorOptions.disabled = !e.row.isNewRow;
  //   }
  // };

  return (
    <DataGrid
      id="EqptArr"
      keyExpr="id"
      dataSource={dataSource}
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      focusedRowEnabled={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      // onEditorPreparing={onEditorPreparing}
    >
      <LoadPanel enabled={true} />

      <FilterRow visible={true} />
      <HeaderFilter visible={true} />

      <StateStoring
        enabled={true}
        type="localStorage"
        storageKey={"EquipmentManagement.Arrangement"}
      />

      <Editing
        mode="form"
        allowUpdating={true}
        allowAdding={true}
        allowDeleting={true}
      >
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation={"top"}
          minColWidth={300}
          colCount={2}
          colCountByScreen={{
            sm: 2,
            md: 4,
          }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="basicInfo"
          // customizeItem={customizeItem}
        ></Form>
      </Editing>

      {(type == "1" || type == "9") && (
        <Column dataField="employeeNo" caption="임직원명">
          <Lookup
            dataSource={employee}
            valueExpr="employeeNo"
            displayExpr="name"
          />
          {/* <FormItem visible={false} /> */}
        </Column>
      )}
      {type == "2" && (
        <Column dataField="loc" caption="위치">
          <Lookup dataSource={LOC} valueExpr="id" displayExpr="name" />
          {/* <FormItem visible={false} /> */}
        </Column>
      )}
      <Column
        dataField="asgmtDate"
        caption="배치일자"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column
        dataField="unasgmtDate"
        caption="회수일자"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
    </DataGrid>
  );
}
